<div class="alert-box-container">
  <div class="alert-box">
    <div class="modal-header">
      <h4 class="modal-title">{{title}}</h4>
    </div>
    <div class="modal-body">
      {{message}}
      <div class="hours">
        {{messageHours}}
      </div>
    </div>
    <div class="modal-footer">
      <button type="button" class="btn cancel" [ngClass]="customClassCancel" (click)="onCancel()"
        onclick="document.getElementsByClassName('speed-actions__full')[0].style.display='flex'">{{btnCancel}}</button>
      <button type="button" class="btn confirm" [ngClass]="customClassConfirm" (click)="onConfirm()"
        onclick="document.getElementsByClassName('speed-actions__full')[0].style.display='flex'">{{btnConfirm}}</button>
    </div>
  </div>
</div>